import map from "lodash/map";
import React from "react";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import { useRillContext } from "../rill/RillReact/share/base";

const PAGES = {
  "Contact Us": "/dashboard/support/contact",
};

function SettingsNav(props) {
  const { t } = useTranslation("dashboard");
  const {
    locals: { pathname },
  } = useRillContext();

  return (
    <aside role="secondary-navbar" tabIndex="-1">
      <h6>{t("supportNav.support")}</h6>
      <ul className="Sidebar-Nav nav">
        {map(PAGES, (url, page) => {
          return (
            <li key={page}>
              <a className={cx({ active: url === pathname })} href={url}>
                {t("supportNav.contactUs")}
              </a>
            </li>
          );
        })}
      </ul>
    </aside>
  );
}

export default SettingsNav;
